import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import clock from "@baseImg/footer/Contacts/icon-clock.svg";
import email from "@baseImg/footer/Contacts/icon-email.svg";
import phone from "@baseImg/footer/Contacts/icon-phone.svg";

const BG = {
	content: [
		{
			firstText: '0:00-24:00 часа',
			secondText: 'Без почивни дни',
			icon: clock,
			iconAlt: 'Работно време'
		},
		{
			firstText: '<a href="mailto:support@superhosting.bg">support@superhosting.bg</a>',
			secondText: '<a href="' + getInitialMeta('profileUrl') + 'web-hosting-client-customer-support.php" title="Техническа поддръжка">Техническа поддръжка</a>',
			icon: email,
			iconAlt: 'Email'
		},
		{
			firstText: '<a href="tel:+359885588822">088 558 88 22</a>',
			secondText: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-contact.php" title="Адрес на офис">Адрес на офис</a>',
			icon: phone,
			iconAlt: 'Телефон'
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	content: [
		{
			firstText: 'Available 24/7',
			secondText: 'No days off.',
			icon: clock,
			iconAlt: 'Working hours'
		},
		{
			firstText: '<a href="mailto:support@superhosting.bg">support@superhosting.bg</a>',
			secondText: '<a href="' + getInitialMeta('profileUrl') + 'web-hosting-client-customer-support.php" title="Technical support">Technical support</a>',
			icon: email,
			iconAlt: 'Email'
		},
		{
			firstText: '<a href="tel:+359885588822">088 558 88 22</a>',
			secondText: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-page-contact.php" title="Office location">Office location</a>',
			icon: phone,
			iconAlt: 'Phone'
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];